import { getRoute, useLayout } from '@/functions';

export default {
    path: '/',
    component: useLayout('blank'),
    children: [
        getRoute('/oauth/google/callback', 'googleOAuthCallback', 'oauth/google_callback_page', { title: 'Google Sign In' }),
        getRoute('/oauth/apple/callback', 'appleOAuthCallback', 'oauth/apple_callback_page', { title: 'Apple Sign In' }),
    ],
};

